export const metrics = [
  { prefix: "", value: "98", suffix: "%", label: "Client retention" },
  { prefix: "<", value: "2", suffix: "hrs", label: "Typical initial response" },
  { prefix: "", value: "15", suffix: "+ yrs", label: "Combined legal experience" },
  { prefix: "", value: "500", suffix: "+", label: "Matters advised on" },
];
